import { ErrorHeader } from "@/components/layouts/ErrorHeader.tsx";
import { UnexpectedErrorIllustration } from "@/components/ui/illustrations/unexpected-error/UnexpectedErrorIllustration.tsx";
import { useSupport } from "@/hooks/useSupport.ts";
import { Button, Div, Flex, H1 } from "@hopper-ui/components";
import { useTranslation } from "react-i18next";

export const isChunkLoadError = (error: unknown) => {
    return error instanceof Error && error.name === "ChunkLoadError";
};

export const ChunkLoadErrorPage = () => {
    const { t } = useTranslation();
    const { contactSupport } = useSupport();

    return (
        <Div
            backgroundColor="core_toad-50"
            position="relative"
        >
            <ErrorHeader />
            <Flex
                justifyContent="center"
                alignItems="center"
                UNSAFE_minHeight="100dvh"
                backgroundColor="core_toad-50"
            >
                <Div
                    textAlign="center"
                    paddingX="inset-md"
                >
                    <Flex
                        alignItems="center"
                        justifyContent="center"
                        UNSAFE_height="11.375rem"
                    >
                        <UnexpectedErrorIllustration />
                    </Flex>
                    <H1
                        margin="core_0"
                        fontSize={{
                            base: "heading-lg",
                            sm: "heading-2xl"
                        }}
                        color="core_rock-800"
                    >
                        {t("errorPages.chunkLoadError.title")}
                    </H1>
                    <Div
                        marginTop="inline-xs"
                        fontSize={{
                            base: "body-sm",
                            sm: "body-md"
                        }}
                        color="core_rock-800"
                    >
                        {t("errorPages.chunkLoadError.description")}
                    </Div>
                    <Button
                        marginX="auto"
                        marginTop="inline-lg"
                        onPress={contactSupport}
                    >
                        {t("errorPages.chunkLoadError.ctaLabel")}
                    </Button>
                </Div>
            </Flex>
        </Div>
    );
};
